import { bootLanguage, renderBootFailure } from "@/i18n/boot";

// The dictionary must be installed before any app module is evaluated:
// status tables, route titles and column definitions call t() at import time
// and are never rebuilt (switching reloads the page). So the app is imported
// only after the language is in place.
// A failed dictionary or app chunk (offline, a deploy replaced the files)
// would otherwise leave a blank page.
void bootLanguage()
  .then(() => import("./main"))
  .catch((err: unknown) => {
    console.error("The app failed to start", err);
    const root = document.getElementById("root");
    if (root) renderBootFailure(root);
  });
